import React from 'react';
import { RouteObject } from 'react-router-dom';
import { Merchants } from './merchant';
import { BranchDetail } from '../aditor-merchants/routes/BranchDetail';

export const MerchantsRoutes: RouteObject[] = [
  {
    path: '',
    children: [
      {
        path: '',
        element: <Merchants />,
      }, {
        path: 'branches/:id',
        element: <BranchDetail />,
      },
    ],
  },
];
